import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'

export default {
	/**
	 * 策略列表
	 * @param {page} 第几页
	 * @param {pageSize} 每页数量
	**/
	strategyList( params={} ) {
		return request({
	    url: baseUrl + '/device/concentrator/Strategy',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 策略编辑
	**/
	strategyEdit(id,data){
		return request({
			url: baseUrl + '/device/concentrator/Strategy/'+id,
			method:'PUT',
			data
		})
	},

	/**
	 * 策略添加
	**/
	strategyAdd(data){
		return request({
			url: baseUrl + '/device/concentrator/Strategy',
			method:'POST',
			data
		})
	},

	/**
	 * 策略删除
	**/
	strategyDel(id){
		return request({
			url: baseUrl + '/device/concentrator/Strategy/'+id,
			method:'DELETE'
		})
	},

	/**
	 * 策略分配-分配或者取消策略
	 * @param {type} 0未分配1已分配
	 * @param {lamp_ids} 1,2,3 所选设备
	 * @param {stg_id} 策略ID
	**/
	foucusAllotFen(data){
		return request({
			url: baseUrl + '/device/concentrator/StrategyFen',
			method:'POST',
			data
		})
	},
	/**
	 * 获取该策略下的集控设备列表
	 * @param {id} 策略ID
	 * @param {pageSize} 每页数量
	**/
	getConcentratorByStrategyId(id, params={} ) {
		return request({
	    url: baseUrl + '/device/concentrator/StrategyList/'+id,
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 根据经纬度查询日落日出时间
	 * @param {longitude, latitude} 经纬度
	**/
	getDateSunInfo( data={} ) {
		return request({
	    url: baseUrl + '/device/getDateSunInfo',
	    method: 'POST',
	    data
	  })
	},

	/**
	 * 禁用或启用集中控制器策略
	**/
	setStrategySte(id,data){  
		return request({
			url: baseUrl + '/device/concentrator/setPlanSte/'+id,
			method:'POST',
			data
		})
	},
}